// src/actions/currentLevelActions.js

export const setCurrentLevel = (level) => {
    return {
      type: "SET_CURRENT_LEVEL",
      payload: level
    };
  };
 
